import { AlertPopup } from "components/alertPopup/alertPopup";

type InsufficientCreditsPopup = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export default function InsufficientCreditsPopup({
  open,
  setOpen,
}: InsufficientCreditsPopup) {
  return (
    <AlertPopup
      headerText="Insufficient Credits"
      height="434px"
      subHeaderText="Your entity does not have sufficient credits to proceed. Please top-up your credits by contacting support@pledgx.ai and try again."
      openPopup={open}
      setOpenPopup={setOpen}
      showIcon={true}
      width={"640px"}
      showButton={false}
      bodyContent={null}
    />
  );
}
